import * as service from './service'
export default {
  namespace: 'customerServiceComplainsDetail',
  state: {
    demoData: {}
  },
  effects: {
    * queryTicketUserRecords ({ payload }, { call, put }) {
      const res = yield call(service.queryTicketUserRecords, payload)
      return res.data
    },
    * urgeTicket ({ payload }, { call, put }) {
      const res = yield call(service.urgeTicket, payload)
      return res.data
    },
    * cancelComplaint ({ payload }, { call, put }) {
      const res = yield call(service.cancelComplaint, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
